/** EFFET : délégué MediaPipe mémorisé sur cet appareil (`localStorage`), choisi par le diagnostic. */
import { DEFAULT_DELEGATE, loadDelegate, saveDelegate, type Delegate } from './delegate';

const storage = (): Storage | null => {
  try {
    return globalThis.localStorage;
  } catch {
    return null;
  }
};

export function preferredDelegate(): Delegate {
  const s = storage();
  return s ? loadDelegate(s) : DEFAULT_DELEGATE;
}

export function rememberDelegate(delegate: Delegate): void {
  const s = storage();
  if (s) saveDelegate(s, delegate);
}
